import { isDevelopment } from "./environment";
import { isLocalStoryBook } from "./isLocalStorybook";

export const getBaseUrl = () => {
  return isLocalStoryBook() || isDevelopment() ? `${location.origin}/` : "/";
};

export default getBaseUrl;
